import { removeNullKeys } from "@dx/components/utils";
import { getNavigateAs } from "../navigateAs";
import { getAuthorizationHeader } from "../sgwt-connect";
import { IUser } from "./users.service.types";
import { debug } from "../../utils";

export async function isSgInternalNetwork(): Promise<boolean> {
  try {
    const url = process.env.REACT_APP_NETWORK_CHECK_URL;
    if (!url) {
      throw Error("Invalid configuration");
    }
    const result = await fetch(url);
    return (await result.json())?.["origin-network"] === "intranet";
  } catch (err) {
    console.error("Failed to check network %O", err);
    return false;
  }
}

export const fetchUser = async (): Promise<IUser> => {
  const url = `${process.env.REACT_APP_USER_SETTINGS_API_URL}/v1/me`;
  const headers = {
    Authorization: await getAuthorizationHeader(url, {
      ignoreNavigateAs: true,
    }),
    "dx-navigate-as": getNavigateAs() ?? null,
  };

  debug("fetch user headers: ", headers);

  const user: IUser = await (
    await fetch(url, {
      headers: removeNullKeys(headers),
    })
  )?.json();

  return user;
};
